import { ReactElement } from 'react';
import styled from 'styled-components';
import COLORS from '../../colors';

interface DefineInputChipProps {
  description: string;
  value: string;
  icon: ReactElement;
  compactView?: boolean;
}

interface ValueContainerProps {
  isCompactView: boolean;
}

const StyledIconContainer = styled.div`
  width: 32px;
  border-radius: 100px;
  background-color: ${COLORS.NEUTRAL_800};
  color: ${COLORS.NEUTRAL_200};
  height: 32px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledValueContainer = styled.div<ValueContainerProps>`
  display: ${(props) => (props.isCompactView ? 'block' : 'flex')};
  flex: 1;
  align-items: center;
`;

const StyledValueContent = styled.div<ValueContainerProps>`
  flex: 1;
  position: relative;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.NAV_ACTIVE};
  text-align: ${(props) => (props.isCompactView ? 'left' : 'right')};
`;

const StyledDefineInputChipContainer = styled.div<ValueContainerProps>`
  width: 100%;
  box-shadow:
    0px 1px 3px 1px rgba(0, 0, 0, 0.15),
    0px 1px 2px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  background-color: ${COLORS.NEUTRAL_900};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: ${(props) => (props.isCompactView ? '10px' : '16px')};
  gap: 8px;
  text-align: left;
  font-size: 13.33px;
  color: ${COLORS.NAV_COMPLETED};
`;

const DefineInputChip = ({
  description,
  value,
  icon,
  compactView = false
}: DefineInputChipProps) => {
  return (
    <StyledDefineInputChipContainer isCompactView={compactView}>
      <StyledIconContainer>{icon}</StyledIconContainer>
      <StyledValueContainer isCompactView={compactView}>
        {description}
        <StyledValueContent isCompactView={compactView}>
          {value}
        </StyledValueContent>
      </StyledValueContainer>
    </StyledDefineInputChipContainer>
  );
};

export default DefineInputChip;
